import { putApiGreetingsOrder } from '@/shared/api'
import { createMutation } from '@farfetched/core'

export const greetingsOrder = createMutation({
  handler: putApiGreetingsOrder,
})
